import React from 'react';
import PropTypes from 'prop-types';
import { Tab, Accordion } from 'react-bootstrap5';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';

import CategoryIconWithTitle from './CategoryIconWithTitle';
import Topic from './Topic';

export default function CategoryBodyItem({ item, topics, updateTopicStatus }) {
  return (
    <Tab.Pane eventKey={`category-${item.id}`} className="px-sm-4 px-xxl-5">
      <Accordion.Item eventKey={`category-${item.id}`}>
        <h4 className="accordion-header">
          <Accordion.Button className="icon-with-text">
            <CategoryIconWithTitle item={item} />
          </Accordion.Button>
        </h4>

        <Accordion.Body>
          <ResponsiveMasonry columnsCountBreakPoints={{ 1: 1, 768: 2, 1200: 3 }}>
            <Masonry gutter="1rem">
              {topics.map((topic) => (
                <Topic
                  key={`topic-${topic.id}`}
                  topic={topic}
                  updateTopicStatus={updateTopicStatus}
                />
              ))}
            </Masonry>
          </ResponsiveMasonry>
        </Accordion.Body>
      </Accordion.Item>
    </Tab.Pane>
  );
}

CategoryBodyItem.propTypes = {
  item: PropTypes.object.isRequired,
  topics: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateTopicStatus: PropTypes.func.isRequired,
};
